import Vue from 'vue'

/**
 * @author Jose Luis R
 * @param id Casualty's id
 * @param requiremenst payload
 * @return {Object}
 */

const sendRequirements = ({ id }, { quantification, buildProcess, materialsQuantity,
  securityTools, projectYield, rescueMatches }) => {
  const payload = {
    quantification,
    build_process: buildProcess,
    materials_quantity: materialsQuantity,
    security_tools: securityTools,
    project_yield: projectYield,
    rescue_matches: rescueMatches
  }

  return Vue.$http.post(`purchase/close_project/${id}/`, payload)
}

export default sendRequirements



// WEBPACK FOOTER //
// ./src/services/sinister/closeProject/sendRequirements.js